import incomeService from '../../services/income'

const state = {
    loading: false,
    errors: null,
    incomes: [],
    inc_ledgeraccs:[]
}

const actions = {
    getAll({ commit }) {
        commit('INCOME_LOADING', true)
        incomeService.getAll().then(
            response => {

                commit('LOAD_INCOMES', response.data)
                commit('INCOME_LOADING', false)
            },
            error => {
                commit('INCOME_FAILURE', error)
                commit('INCOME_LOADING', false)
            }
        )
    },
    add({ commit }, data) {
        commit('INCOME_LOADING', true)
        commit('INCOME_FAILURE', null)
        incomeService.add(data).then(
            response => {
                data.id = response.data.id
                data.recorded_by = response.data.recorded_by
                data.ledgeracc = response.data.ledgeracc
                commit('ADD_INCOME', data)
                commit('INCOME_LOADING', false)
            },
            error => {
                commit('INCOME_FAILURE', error)
                commit('INCOME_LOADING', false)
            }
        )
    },
    update({ commit }, data) {
        commit('INCOME_LOADING', true)
        commit('INCOME_FAILURE', null)
        incomeService.update(data.income)
            .then(
                response => {
                    data.income.ledgeracc = response.data.ledgeracc
                    commit('UPDATE_INCOME', data)
                    commit('INCOME_LOADING', false)
                },
                error => {
                    commit('INCOME_FAILURE', error)
                    commit('INCOME_LOADING', false)
                }
            )


    },
    delete({ commit }, data) {
        commit('INCOME_LOADING', true)
        commit('INCOME_FAILURE', null)
        incomeService.delete(data.income.id)
            .then(
                response => {

                    commit('DELETE_INCOME', data)
                    commit('INCOME_LOADING', false)
                },
                error => {
                    commit('INCOME_FAILURE', error)
                    commit('INCOME_LOADING', false)
                }
            )
    }
}

const mutations = {
    ADD_INCOME(state, payload) {
        state.incomes.unshift(payload);
    },
    LOAD_INCOMES(state, payload) {
        state.incomes = payload.incomes
        state.inc_ledgeraccs = payload.ledgeraccs
    },
    UPDATE_INCOME(state, payload) {
      console.log(payload)
        Object.assign(state.incomes[payload.index], payload.income);
    },
    DELETE_INCOME(state, payload) {
        state.incomes.splice(payload.index, 1)
    },
    INCOME_FAILURE(state, payload) {
        state.errors = payload
    },

    INCOME_LOADING(state, payload) {
        state.loading = payload
    },
}


const getters = {
    INCOMES: state => {
        return state.incomes
    },

    INCOME_LEDGERACCS: state => {
      return state.inc_ledgeraccs
  },


    INCOME_ERROR: state => {
        return state.errors
    },

    INCOME_LOADING: state => {
        return state.loading
    }
}

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}
